import { getSct2Parameters, patchSct2Parameters } from '../../api/parameters.api'

const state = {
  sct2_params: null,
  sct2_params_initial: null,
  isParamsValid: false,
  batteryLife: { min: 0, max: 0 },
}

const getters = {
  async getSct2Params(state) {
    return state.sct2_params
  },
  getBatteryLife(state) {
    return state.batteryLife
  },
  getIsParamsValid(state) {
    return state.isParamsValid
  },
  getRequestedMode(state) {
    return state.sct2_params?.requested_mode ?? null
  },
  getRequestedModeUpdated(state) {
    return state.sct2_params?.requested_mode_updated ?? null
  },
  hasParamsChanged(state) {
    if (!state.sct2_params || !state.sct2_params_initial) return false
    const keys = ['frequency', 'keepalive_period', 'temp_slice_duration']
    return keys.some((k) => state.sct2_params[k] !== state.sct2_params_initial[k])
  },
}

const actions = {
  async fetchSct2Params({ commit }, sct2_id) {
    try {
      const response = await getSct2Parameters(sct2_id)
      commit('SET_SCT2_PARAMS', response.data)
      commit('SET_SCT2_PARAMS_INITIAL', response.data)
    } catch (error) {
      console.error('fetchSct2Params', error)
    }
  },
  async patchSct2Params({ commit }, data) {
    try {
      const response = await patchSct2Parameters(data)
      if (response.data) {
        commit('SET_SCT2_PARAMS', response.data)
        commit('SET_SCT2_PARAMS_INITIAL', response.data)
      }
    } catch (error) {
      console.error('patchSct2Params', error)
    }
  },
  async setSct2Params({ commit }, data) {
    let batterylife = { min: 0, max: 0 }
    commit('SET_SCT2_PARAMS', data)
    if (
      data.frequency >= 1 &&
      data.frequency <= 180 &&
      Number.isInteger(data.frequency) &&
      data.keepalive_period >= 1 &&
      data.keepalive_period <= 1440 &&
      Number.isInteger(data.keepalive_period) &&
      (data.temp_slice_duration == 0 || (data.temp_uplink_slices_duration == 2 && (data.temp_slice_duration == 60 || data.temp_slice_duration == 720)))
    ) {
      commit('SET_IS_PARAMS_VALID', true)
    } else {
      commit('SET_IS_PARAMS_VALID', false)
    }
    if (data.frequency >= 1) {
      batterylife.min = Math.round(12600 / (3 + (8 * 72) / data.frequency) / 30)
      batterylife.max = Math.round(12600 / (3 + (2 * 72) / data.frequency) / 30)
      commit('SET_SCT2_BATTERYLIFE', batterylife)
    }
  },
}

const mutations = {
  SET_SCT2_PARAMS(state, data) {
    state.sct2_params = data
  },
  SET_SCT2_PARAMS_INITIAL(state, data) {
    state.sct2_params_initial = {
      frequency: data.frequency,
      keepalive_period: data.keepalive_period,
      temp_slice_duration: data.temp_slice_duration,
    }
  },
  SET_SCT2_BATTERYLIFE(state, data) {
    state.batteryLife = data
  },
  SET_IS_PARAMS_VALID(state, data) {
    state.isParamsValid = data
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
